import styled from "styled-components";

export const FooterSection = styled.section`
  background: #29598f;
  margin: 0 auto;
  overflow: hidden;
  color: #a9c5e6;
  text-align: center;
  padding: 2rem calc((95vw - 1000px) / 2);
`;
